/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Membership_Option_Pending_RemovalInputs */

const fr_membership_option_pending_removal = /** @type {(inputs: Membership_Option_Pending_RemovalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'option sera retirée le ${i?.date}.`)
};

/**

* @param {Membership_Option_Pending_RemovalInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_option_pending_removal = /** @type {((inputs: Membership_Option_Pending_RemovalInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Option_Pending_RemovalInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_option_pending_removal(inputs)
});